import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const LoaderWrapper = styled.div`
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SecondaryText = styled.div`
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  margin-bottom: 12px;
`

export const PaymentMethodsContainer = styled.div`
  position: relative;
  flex: 1;
  margin-bottom: var(--space-500);
`

export const PaymentMethodsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: var(--space-n700);
  right: var(--space-n700);
  bottom: 0;
  padding: 0 var(--space-700);
  overflow: auto;
`

export const TotalSummaryContainer = styled.div`
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`
